"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CounterComponent = /** @class */ (function () {
    function CounterComponent() {
        this.currentCount = 0;
    }
    CounterComponent.prototype.incrementCounter = function () {
        this.currentCount++;
    };
    return CounterComponent;
}());
exports.CounterComponent = CounterComponent;
